export default {"src":"/_next/static/media/customer_centricity_icon.054e0402.svg","height":59,"width":59,"blurWidth":0,"blurHeight":0};